import { ButtonCommon } from "components/common";
import { PencilSimple, X } from "@phosphor-icons/react";
import { StaffDetailHeaderProps } from "types/staff-detail.types";

const StaffDetailHeader: React.FC<StaffDetailHeaderProps> = ({
  fullName,
  role,
  staffCode,
  phoneNumber,
  department,
  avatarImage,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  onTerminate,
  showOnlySave,
  codeLabel = "Mã nhân viên:",
  phoneLabel = "Số điện thoại:",
  departmentLabel = "Phòng ban:",
  showTerminateButton = true,
}) => {
  return (
    <div className="bg-white px-4 lg:px-6 py-4 border-b border-gray-200">
      {/* Container chính*/}
      <div className="flex flex-col lg:flex-row justify-between items-start gap-6">
        {/* LEFT SECTION */}
        <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
          {/* Avatar */}
          <div className="flex-shrink-0 mx-auto sm:mx-0">
            {avatarImage ? (
              <img
                src={avatarImage}
                alt={fullName}
                className="w-20 h-20 lg:w-[92px] lg:h-[92px] rounded-full object-cover"
              />
            ) : (
              <div className="w-20 h-20 lg:w-[92px] lg:h-[92px] rounded-full bg-gray-300" />
            )}
          </div>
          {/* Info header */}
          <div className="flex-1 text-center sm:text-left">
            <h2 className="text-xl font-bold pb-1 text-blue-600 capitalize">
              {fullName}
            </h2>
            <p className="text-[12px] pb-3 text-blue-500 font-medium">{role}</p>

            {/* Thông tin chi tiết */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-y-2 gap-x-6 text-sm">
              <div className="flex items-center justify-center sm:justify-start gap-1">
                <span className="text-gray-400 whitespace-nowrap min-w-[126px]">
                  {codeLabel}
                </span>
                <span className="text-black font-medium min-w-[125px]">
                  {staffCode}
                </span>
              </div>
              <div className="flex items-center justify-center sm:justify-start gap-1">
                <span className="text-gray-400 whitespace-nowrap min-w-[126px]">
                  {phoneLabel}
                </span>
                <span className="text-black font-medium min-w-[125px]">
                  {phoneNumber}
                </span>
              </div>
              <div className="flex items-center justify-center sm:justify-start gap-1">
                <span className="text-gray-400 whitespace-nowrap min-w-[126px]">
                  {departmentLabel}
                </span>
                <span className="text-black font-medium ml-2 min-w-[125px]">
                  {department}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT SECTION (Buttons) */}
        <div className="flex flex-wrap justify-center lg:justify-end gap-2 w-full lg:w-auto pt-2 lg:pt-0 border-t lg:border-t-0 border-gray-100">
          {showOnlySave ? (
            <ButtonCommon
              icon={<PencilSimple size={18} />}
              color="primary"
              radius="rounded"
              onClick={onSave}
              className="w-full sm:w-auto"
            >
              Lưu thông tin
            </ButtonCommon>
          ) : !isEditing ? (
            <ButtonCommon
              icon={<PencilSimple size={18} />}
              color="primary"
              radius="rounded"
              onClick={onEdit}
              className="w-full sm:w-auto"
            >
              Chỉnh sửa thông tin
            </ButtonCommon>
          ) : (
            <div className="flex flex-wrap gap-2 w-full justify-center lg:justify-end">
              {showTerminateButton && (
                <ButtonCommon
                  icon={<X size={18} weight="bold" />}
                  color="danger"
                  radius="rounded"
                  onClick={onTerminate}
                  className="flex-1 sm:flex-none"
                >
                  Ngưng hợp tác
                </ButtonCommon>
              )}
              <ButtonCommon
                icon={<X size={18} weight="bold" />}
                color="soft"
                radius="rounded"
                onClick={onCancel}
                className="flex-1 sm:flex-none text-[#012643]"
              >
                Hủy
              </ButtonCommon>
              <ButtonCommon
                icon={<PencilSimple size={18} />}
                color="primary"
                radius="rounded"
                onClick={onSave}
                className="w-full sm:w-auto"
              >
                Lưu thay đổi
              </ButtonCommon>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StaffDetailHeader;
